module.exports = __webpack_public_path__ + "static/media/aspen.20a0633e.PNG";